import React, { useMemo } from 'react';
import LwtTable from 'components/@common/Table/LwtTable';
import { useTranslation } from 'react-i18next';
import singleModuleTableCol from './singleModuleTableCol';
import { upperCase } from 'lodash';
import {
  getHasTwoAttempts,
  isAllSelected
} from 'components/ReportsModule/components/KeyboardingReport/keyboarding-report-util';
import useStore from 'store';
import ConstructAResponseModal from 'components/ReportsModule/components/KeyboardingReport/AccessmentAcceleratorComponents/ConstructAResponseModal';
import { makeStyles } from '@material-ui/core';
import getColumns from '../../../../AccessmentAcceleratorComponents/allModulesTableCol';

type Props = {
  selectedModule?: any;
  data: any[];
};

const StudentAssessmentAcceleratorTable: React.FC<Props> = ({ selectedModule, data }) => {
  const classes = useStyles();
  const { t } = useTranslation(['Reports', 'ReportsHelpCommon', 'ReportsHelpTableColumns']);
  const asUpperCase = (value: any) => upperCase(t(value));
  const [, { openQuarterModal }] = useStore();

  const handleIconClick = (data: any) => {
    openQuarterModal({
      body: <ConstructAResponseModal data={data} />,
      options: {
        paperProps: { className: classes.modalContainer }
      }
    });
  };

  const hasTwoAttempts = useMemo(
    () => getHasTwoAttempts(data),
    // eslint-disable-next-line
    [!isAllSelected(selectedModule), data]
  );

  const getFilterActivityKey = (data: any[]) => {
    if (data[0]?.a2_question) return 'a1';
    if (data[0]?.a1_question) return 'a2';
  };
  const columns = isAllSelected(selectedModule)
    ? getColumns(asUpperCase)
    : singleModuleTableCol(
        asUpperCase,
        handleIconClick,
        !hasTwoAttempts,
        getFilterActivityKey(data)
      );

  return <LwtTable options={{ sortable: true }} columns={columns} data={data} />;
};

const useStyles = makeStyles(() => ({
  modalContainer: {
    width: 400
  }
}));
export default StudentAssessmentAcceleratorTable;
